import * as React from 'react';
import './styles.css';
export function GridComponent(props) {
    return (React.createElement("div", { className: "dashboard-risk-score__form-row", style: {
            gridTemplateColumns: `minmax(200px, 350px) repeat(${props.size}, minmax(155px, 200px))`,
            marginBottom: (props.bottom != null ? props.bottom : "10px")
        } }, props.children));
}
export default GridComponent;
